import { Grid, Typography } from '@mui/material'
import React, { useEffect } from 'react'
import { useFormContext } from 'react-hook-form'
import { ControlledDatePicker } from '../ControlledDatePicker'
import { FieldContainer } from '../FieldContainer'
import { BudgetRangeSelect } from './BudgetRangeSelect'

export const TimelineAndBudgetFields = () => {
  const { watch, setValue } = useFormContext()
  const tom = new Date().valueOf() + 1000 * 3600 * 24
  const startDate = watch('campaign.start', tom)
  const endDate = watch('campaign.end', tom)
  const proposalDate = watch('campaign.proposalDate', tom)

  useEffect(() => {
    if (new Date(startDate) > new Date(endDate)) {
      setValue('campaign.end', new Date(startDate))
    }
  }, [startDate])

  useEffect(() => {
    if (new Date(proposalDate) > new Date(startDate)) {
      setValue('campaign.start', new Date(proposalDate))
    }
  }, [proposalDate])

  return (
    <FieldContainer>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant='h6'>Timeline and Budget</Typography>
        </Grid>
        <Grid item xs={12} md={6}>
          <ControlledDatePicker
            name='campaign.proposalDate'
            label='Expected Proposal Date'
            initialFocusedDate={tom}
            minDate={tom}
            defaultValue={tom}
          />
        </Grid>
        <Grid item xs={12} md={6}></Grid>
        <Grid item xs={12} md={6}>
          <ControlledDatePicker
            name='campaign.start'
            label='Campaign Start'
            initialFocusedDate={proposalDate}
            minDate={proposalDate}
            defaultValue={tom}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <ControlledDatePicker
            name='campaign.end'
            label='Campaign End'
            initialFocusedDate={startDate}
            minDate={startDate}
            defaultValue={tom}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <BudgetRangeSelect />
        </Grid>
      </Grid>
    </FieldContainer>
  )
}
